<main class="flex items-center justify-between px-4 min-h-screen bg-gradient-to-r from-lBlack to-lBlue700">
  <section class="flex flex-col items-start justify-center w-full lg:max-w-[45%] gap-8">
    <div class="w-full flex flex-col gap-6 items-center justify-center mx-auto lg:max-w-[80%]">
      <div class="space-y-4">
        <h1 class="text-lPrimary text-[10rem] font-bold leading-none md:text-[12rem]">404</h1>
        <h2 class="text-lWhite text-[2.5rem] leading-[3rem] font-semibold md:text-[3.3rem]">Página não encontrada</h2>
        <p class="text-lSecondary text-base !m-0 !mt-3">
          A página que você está procurando pode ter sido removida ou estar temporariamente indisponível
        </p>
      </div>

      <div class="w-full flex justify-center md:justify-start">
        <button
          (click)="goToLogin()"
          type="button"
          lButton
          [bType]="buttonTypes.PRIMARY"
          [bRadius]="buttonRadius.LARGE"
          [bSize]="buttonSizes.MEDIUM"
          class="animate-fadeIn md:!w-80"
        >
          <span>Acessar tela inicial</span>
        </button>
      </div>
    </div>
    
  </section>

  <aside class="hidden lg:flex flex-1 h-screen items-center justify-center">
    <div class="flex items-center relative w-[90%] h-[80%] mt-10">
      <l-animated-banner class="w-full h-full" />
    </div>
  </aside>
</main>
